import template from './check-service.jade';

export default ['placingTermsApi', function(placingTermsApi) {
	return {
		template,
		restrict: 'AE',
		scope: {},
		bindToController: {
			onOk: '&',
		},
		controller: function() {
			this.message = placingTermsApi.checkServiceData.unavailableCheckServiceMessage;
		},
		controllerAs: 'c'
	}
}];
